import { c as _c } from "react/compiler-runtime";
import { requestIdleCallback } from '@cc-shopping/utils/requestIdleCallback';
import { RadioGroup } from '@mui/material';
import type { ChangeEvent } from 'react';
import { useFiltersAnalytics } from 'src/features/roundup-filters/store/hooks/useFiltersAnalytics';
import { useShallow } from 'zustand/shallow';
import { CARD_FEATURES_OPTIONS } from '../../../config';
import { useOffersFilterStore } from '../../../store/Context';
import { type FilterOffersByType, FilterType } from '../../../store/enums';
import type { OffersFilterStoreState } from '../../../store/types';
import { Accordion } from '../InputAccordion/Accordion';
import { FormLabeledListItem } from '../InputAccordion/FormLabeledListItem';
import { RadioButton } from '../InputAccordion/SimpleSelect/RadioButton';
export function CardFeatures() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Accordion title="Card features"><CardFeaturesWrapper id="card-features">{CARD_FEATURES_OPTIONS.map(_temp)}</CardFeaturesWrapper></Accordion>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(option) {
  return <FormLabeledListItem key={option.value} control={<RadioButton value={option.value} />} label={option.label} value={option.value} />;
}
function CardFeaturesWrapper(t0) {
  const $ = _c(9);
  const {
    id,
    children
  } = t0;
  const {
    cardFeatureFilter,
    handleApplyFilters,
    handleSingleFormUpdate
  } = useOffersFilterStore(useShallow(_temp2));
  const {
    fireCardFeatureUpdateEvents
  } = useFiltersAnalytics();
  let t1;
  if ($[0] !== fireCardFeatureUpdateEvents || $[1] !== handleApplyFilters || $[2] !== handleSingleFormUpdate) {
    t1 = (_, value) => {
      const typedValue = value as FilterOffersByType;
      handleSingleFormUpdate({
        value: typedValue,
        type: FilterType.CARD_FEATURE
      });
      requestIdleCallback(() => {
        handleApplyFilters();
        fireCardFeatureUpdateEvents(typedValue);
      });
    };
    $[0] = fireCardFeatureUpdateEvents;
    $[1] = handleApplyFilters;
    $[2] = handleSingleFormUpdate;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleChange = t1;
  let t2;
  if ($[4] !== cardFeatureFilter || $[5] !== children || $[6] !== handleChange || $[7] !== id) {
    t2 = <RadioGroup name={id} value={cardFeatureFilter} onChange={handleChange}>{children}</RadioGroup>;
    $[4] = cardFeatureFilter;
    $[5] = children;
    $[6] = handleChange;
    $[7] = id;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
function _temp2(state) {
  return {
    handleApplyFilters: state.handleApplyFilters,
    handleSingleFormUpdate: state.handleSingleFormUpdate,
    cardFeatureFilter: state.filterFormState.cardFeatureFilter
  };
}